(function () {
  function fixProductFormLayout() {
    var qtyForm = document.querySelector('.product-form__input.product-form__quantity');
    var buttons = document.querySelector('.product-form__buttons');
    if (!qtyForm || !buttons) return;
    if (buttons.contains(qtyForm)) return; // already moved

    buttons.insertBefore(qtyForm, buttons.firstChild);
    qtyForm.style.margin = '0';
    qtyForm.style.padding = '0';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixProductFormLayout);
  } else {
    fixProductFormLayout();
  }

  document.addEventListener('shopify:section:load', fixProductFormLayout);
  document.addEventListener('shopify:section:reorder', fixProductFormLayout);
})();